import tuijianImg from '../assets/holder.png';
import { List, Row, Col } from 'antd';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import unit from '../unit';

// 股东增减仓
const IncreaseSidebar = (props) => {
    const navigate = useNavigate();
    const [name, setName] = useState('股东');
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true); 

    const getSourceList = (type) => {
        const path = '/pc/Gudong/getStockAddRank';
        unit.httpGet(path, { "type": type }, (data) => {
            setName(data.name);
            if (data.list && data.list.length > 0) {
                const _dataSource = data.list.map((item, index) => ({
                    key: item.stock_code,
                    index: index + 1,
                    stock_name: item.stock_name,
                    stock_code: item.stock_code, 
                    change_percent: item.change_percent, 
                }));
                setDataSource(_dataSource);
            }
            setLoading(false); 
        });
    }

    useEffect(() => {
        const type = props.type;
        getSourceList(type);
    }, [props.type]);

    return (
        <div className='content-block'>
            <div className='block-title' style={{ background: "linear-gradient( 180deg, #D5E2FF 0%, #FFFFFF 100%)" }}>
                <img className='title-icon' src={tuijianImg} alt="推荐图标" /> 
                <span style={{ verticalAlign: 'middle', marginLeft: '6px'}}>{name}股东增减仓</span>
            </div>
            {loading ? (
                <div style={{ textAlign: 'center', padding: '20px' }}>加载中...</div>
            ) : (
                <List
                    itemLayout="horizontal"
                    size="small"
                    split={false}
                    locale={{emptyText: "暂无数据" }} 
                    dataSource={dataSource}
                    renderItem={(item) => (
                        <List.Item key={item.key} onClick={() => navigate(`/particulars/${item.stock_code}`)}>
                            <Row style={{ width: '100%', height: '100%' }}>
                                <Col style={{ textAlign: 'center', width: '11px', fontSize: '14px' }}>
                                    <div>
                                        <span className={unit.getTextClassName(item.index - 1)}>{item.index}</span>
                                    </div>
                                </Col>
                                <Col span={12} style={{ textAlign: 'left', padding: '0 10px', fontSize: '14px' }}>
                                    <div>
                                        {item.stock_name}
                                    </div>
                                </Col>
                                <Col span={6} style={{ textAlign: 'right', fontSize: '14px', color: '#999999' }}>
                                    <div>持仓变动</div>
                                </Col>
                                <Col span={4} style={{ textAlign: 'right',  padding: '0 10px', fontSize: '14px' }}>
                                    <div style={{ color: item.change_percent > 0 ? '#F23031' : '#00A870' }}>
                                        {item.change_percent}%
                                    </div>
                                </Col>
                            </Row>
                        </List.Item>
                    )}
                />
            )}
        </div>
    );
}

export default IncreaseSidebar;